import { Controller } from "stimulus"
export default class extends Controller {
  // <script src="https://js.braintreegateway.com/web/3.62.0/js/client.min.js"></script>
  // <script src="https://js.braintreegateway.com/web/3.62.0/js/data-collector.min.js"></script>

  connect(){
    console.log('connected')
    let t = this;
    t.loadScripts(['https://js.braintreegateway.com/web/3.62.0/js/client.min.js',
      'https://js.braintreegateway.com/web/3.62.0/js/data-collector.min.js'], this.getDeviceData.bind(this))
  }

  getDeviceData(){
    let t = this;
    braintree.client.create({
      authorization: t.data.get('token') 
    }).then(function (clientInstance) {

      return braintree.dataCollector.create({
        client: clientInstance,
        paypal: true
      }).then(function (dataCollectorInstance) {
        t.element.value = dataCollectorInstance.deviceData;
      });
    }).catch(function (err) {
      console.log(err);
    });
  }

  loadScripts(urls, callback){
    $.getMultiScripts = function(arr, path) {
      var _arr = $.map(arr, function(scr) {
        return $.getScript( (path||"") + scr );
      });

      _arr.push($.Deferred(function( deferred ){
        $( deferred.resolve );
      }));
      return $.when.apply($, _arr);
    }
    $.getMultiScripts(urls).done(function(){
      callback()
    }).fail(function(error){
      console.log(error);
    })
  }

}



// WEBPACK FOOTER //
// ./app/javascript/store_front/controllers/braintree_device_data_controller.js